import { render, staticRenderFns } from "./MarqetaCardRequest.vue?vue&type=template&id=4f71259f&scoped=true"
import script from "./MarqetaCardRequest.vue?vue&type=script&lang=js"
export * from "./MarqetaCardRequest.vue?vue&type=script&lang=js"
import style0 from "./MarqetaCardRequest.vue?vue&type=style&index=0&id=4f71259f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f71259f",
  null
  
)

export default component.exports